// Platform-wide referral link: `?ref=0x...` on any page is remembered in this browser and sent with the player's
// bets in every game, until the player's referrer is recorded on-chain (LBReferral keeps the first one for good)
const KEY = 'lb-referrer';
const isAddress = (value) => typeof value === 'string' && /^0x[a-fA-F0-9]{40}$/.test(value);

const refFromUrl = () => {
  const { search, hash } = window.location;
  const query = new URLSearchParams(search);
  const hashQuery = new URLSearchParams(hash.includes('?') ? hash.slice(hash.indexOf('?')) : '');
  const value = hashQuery.get('ref') || query.get('ref') || hashQuery.get('r') || hashQuery.get('referral');
  return isAddress(value) ? value : null;
};

/** Remembers the referral link of the URL (call on load and on every navigation) */
export const captureReferrer = () => {
  const ref = refFromUrl();
  if (!ref) return;
  try {
    localStorage.setItem(KEY, ref);
  } catch (err) {
    // private mode: the link still works for this page view through the URL
  }
};

/** The referral link to send with a bet: never the player itself */
export const storedReferrer = (self) => {
  let ref = refFromUrl();
  if (!ref) {
    try {
      ref = localStorage.getItem(KEY);
    } catch (err) {
      ref = null;
    }
  }
  if (!isAddress(ref) || (self && ref.toLowerCase() === self.toLowerCase())) return null;
  return ref;
};

/** The player's own link: opens the site with their address as referrer */
export const referralLink = (address) =>
  address ? `${window.location.origin}${window.location.pathname}#/?ref=${address}` : '';
